// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".closed-seperator{padding:3rem 0.5rem 0.75rem 0.5rem;border-bottom:1px solid var(--border-color);background:var(--main-bg-color);margin-top:-0.5rem;text-transform:uppercase}.page-content>.closed-seperator:first-child{margin-top:0rem}\n", ""]);
// Exports
module.exports = exports;
